var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../../components/templates/flex";
import { getColor } from "../../../theme";
var Container = styled(Flex).attrs({
    width: "100%",
    height: "100%",
    flex: true,
    basis: "0%",
    position: "relative",
    overflow: { vertical: "hidden", horizontal: "auto" },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -ms-overflow-style: none;\n  overflow: -moz-scrollbars-none;\n\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n"], ["\n  -ms-overflow-style: none;\n  overflow: -moz-scrollbars-none;\n\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n"])), getColor("selected"));
export default Container;
var templateObject_1;
